// API Helper Utilities to eliminate redundancy

// Get auth token from localStorage
export const getAuthToken = () => {
  return localStorage.getItem('adminToken');
};

// Create authorization headers
export const createAuthHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Standard API request with auth
export const apiRequestWithAuth = async (url, options = {}) => {
  const token = getAuthToken();
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers
    },
    ...options
  };

  try {
    const response = await fetch(url, config);
    if (!response.ok) {
      throw new Error(`https error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    // // console.log('API Request Error:', error);
    throw error;
  }
};

// Loading state wrapper
export const withLoading = async (setLoading, asyncFunction) => {
  try {
    setLoading(true);
    return await asyncFunction();
  } finally {
    setLoading(false);
  }
};

// Error handler
export const handleApiError = (error, setError) => {
  // // console.log('API Error:', error);
  const errorMessage = error.response?.data?.message || error.message || 'An error occurred';
  setError(errorMessage);
};

// Success handler
export const handleApiSuccess = (data, setSuccess) => {
  setSuccess(data.message || 'Operation completed successfully');
  setTimeout(() => setSuccess(''), 3000); // Auto-clear after 3 seconds
};
